<script lang="ts">
	import { onMount } from 'svelte';
	import { isTouchDevice } from '@lib/helpers/global';
	import { createFloatingActions } from 'svelte-floating-ui';
	import { flip, shift, type Placement } from 'svelte-floating-ui/dom';
	import { fly } from 'svelte/transition';
	import { isLockScroll } from '@lib/stores/main-layout.store';

	export let panelPlacement: Placement = 'bottom',
		isShowPanel = false;

	let isTouchDeviceState = false;

	function handlePanel(event: Event) {
		const eventType = event.type as 'mouseenter' | 'mouseleave';
		if (!isTouchDeviceState) isShowPanel = eventType === 'mouseenter';
	}

	onMount(() => (isTouchDeviceState = isTouchDevice()));

	const [floatingRef, floatingContent] = createFloatingActions({
		strategy: 'absolute',
		placement: panelPlacement,
		middleware: [flip(), shift({ crossAxis: true, padding: 20 })]
	});

	$: $isLockScroll = isShowPanel;
</script>

<svelte:window on:resize={() => (isTouchDeviceState = isTouchDevice())} />

<div role="presentation" on:mouseenter={handlePanel} on:mouseleave={handlePanel}>
	<div use:floatingRef>
		<slot name="trigger" />
	</div>
	{#if isShowPanel}
		<div class="absolute z-10" use:floatingContent transition:fly={{ y: 50 }}>
			<slot name="content" />
		</div>
	{/if}
</div>
